import * as $ from 'jquery';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker.js';

window.jQuery = window.$ = $;



// WEBPACK FOOTER //
// ./src/include/jquery.js